<template lang="pug">
//- 首頁
.home-index.page-index(v-if="!$root.isSmLoading")
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .row.home-content
    .content-left.padding-right-none
      HomeMain(
        :switch_status="timetable_switch_status",
        @clickSwitch="clickSwitch"
      )
    .content-right
      //- 您的課程
      .personal-course.animated-3.fadeIn(v-if="!timetable_switch_status")
        .timetable-top
          .timetable-top-title 您的課程
          .timetable-top-date {{ $root.date_filter }}
          .timetable-top-num {{ timetable_data.length }}
          .clearfix
        HomeTimeTable(use_type="home")

      //- 推薦課程
      //- .personal-course.animated-3.fadeIn(v-else)
        .timetable-top
          .timetable-top-title 推薦課程
          .timetable-top-date {{ $root.date_filter }}
          .timetable-top-num {{ timetable_data.length }}
          .clearfix
        HomeTimeTable(use_type="recommend", :timetable_data="timetable_data")
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import HomeMain from '@/components/home/home-main'
import HomeTimeTable from '@/components/home/home-timetable'
export default {
  name: 'home',
  components: {
    ContentTop,
    HomeMain,
    HomeTimeTable
  },
  data () {
    return {
      timetable_switch_status: false,
      //- 課程data
      timetable_data: [],
    };
  },
  async created () {
    // 關閉載入中
    setTimeout(() => { this.$root.closeLoading() }, 250)
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    clickSwitch (_status) {
      this.timetable_switch_status = _status
    }
  }
}
</script>
<style lang="sass">
</style>
